export default "__VITE_ASSET__fT966WeJ__"